module.exports = __webpack_public_path__ + "img/5.2b8acba9.jpg";